<template>
  <div class="summary-section">
    <h2
      class="summary-section__heading heading--3"
      data-test-id="summary-section-heading"
    >{{ heading }}
    </h2>
    <slot name="actions" />
    <div class="summary-section__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummarySection',
  props: {
    heading: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss"> // no scoped - because classes are used in slotted components
  @import '@/stylesheets/components/_summary-section';
</style>
